import React from 'react'
import DashboardHeader from '../Integration/DashboardHeader'
import SuplierDash from '../Integration/SuplierDash'
import FbBusinessProfile from '../../Middleware/Firebase/FbBusinessProfile'

function PageSupplierProfile() {
  return (
    <div>
      
      
<DashboardHeader/>
<SuplierDash/>
<FbBusinessProfile/>


    </div>
  )
}

export default PageSupplierProfile